
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item,
  CandidateGet,
  MDelete
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import Auth from "@/lib/common/auth";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import CandidateMRepeatCreateForm, {
  RepeatMCreate
} from "@/lib/form/candidate/CandidateMRepeatCreateForm";

@Component({
  components: {}
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedItem!: CandidateV3Item;
  @Prop() selectedIdList!: number[];
  @Prop({ default: false }) visible!: boolean;

  singleParam = new CandidateRepeatCreateForm();
  param = new RepeatMCreate();
  single = 0;

  created() {
    this.single = this.selectedIdList.length <= 1 ? 1 : 2; // 1单个2多个
    this.singleParam.candidateId = this.selectedItem.candidateId;
    this.param.candidateIdList = this.selectedIdList;
  }

  submit() {
    if (this.single === 1) {
      //单个邀请重面
      this.singleParam.examId = this.selectedItem.examId;
      this.singleParam.companyId = parseInt(Auth.companyId);
      this.singleParam.sendMessage = 1;
      this.singleParam.candidateId = this.selectedItem.candidateId;
      CandidateV3Custom.candidateRepeatCreate(this.singleParam)
        .then((resp: any) => {
          if (resp.code === 0) {
            this.$message.success("邀请成功");
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.sure();
          this.cancel();
        });
    } else {
      this.param.candidateIdList = this.selectedIdList;
      CandidateV3Custom.repeatMCreate(this.param)
        .then((resp: any) => {
          if (resp.code === 0) {
            let finishedAll = false; //默认添加的所有人里面包含没有完成答题的候选人
            if (resp.data.length > 1) {
              resp.data.forEach((repeatRes: any) => {
                if (repeatRes?.isOk) {
                  finishedAll = true;
                }
              });
            }
            if (finishedAll) {
              this.$message.success("邀请成功");
            } else {
              this.$message.warning("邀请重面的候选人尚未完成面试");
            }
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.sure();
          this.cancel();
        });
    }
  }

  @Emit()
  cancel() {
    return true;
  }

  @Emit()
  sure() {
    return true;
  }
}
